export default "__VITE_ASSET__CYKdD8Zf__"